import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BAND_ACTIONS, EventTravelLegType, TravelLegType } from "Bands/types";
import { copy } from "shared/assets";
import { IAPIState, IStatus } from "shared/types";
import { dataMetaSelector, deleteTravelLeg } from "Bands/state";
import { addTemporaryToast } from "shared/components/Toast";
import { DeleteModal } from "shared/components";
import { useClearActionMetaOnUnMount } from "Bands/utils";

const deleteCopy = copy.travelBlock.travelLeg.delete;

interface Props {
  blockId: string;
  travelLeg: EventTravelLegType;
  travelLegType: TravelLegType;
  handleClose: () => void;
}

export const DeleteTravelLegModal: React.FC<Props> = ({
  blockId,
  travelLeg,
  travelLegType,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteTravelLeg));

  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteTravelLeg);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteCopy.messages.success,
        })
      );

      handleClose();
    }
  }, [apiMeta?.status, dispatch, handleClose]);

  const handleDelete = () => {
    dispatch(
      deleteTravelLeg({
        id: travelLeg.id,
        blockId,
        travelLegType,
      })
    );
  };

  return (
    <DeleteModal
      name=""
      type="travel leg"
      handleDelete={handleDelete}
      handleClose={handleClose}
      apiMeta={apiMeta}
      message={travelLeg.hasBookingReferencesOrTickets ? deleteCopy.messages.warning : null}
    />
  );
};
